import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { fetchFinanceLedgersLi } from "../../../services/Settings/dropdown"

/**
 * Multi-select of individual subledger accounts (ledgers with is_subledger = 1), for a ledger's
 * "Subledger Applicable" setting. The picked subledgers are exactly the ones offered at voucher
 * entry for a line hitting this ledger. Value = array of { label, value }.
 */
const SubledgersMultiLi = ({ control, name, placeholder, invalid, target, disabled }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const res = await fetchFinanceLedgersLi("", "", "", "", true)
        setOptions((res?.data || []).map(l => ({ label: l.name, value: l.id })))
      } catch (e) {
        setOptions([])
      }
    })()
  }, [])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <Select
          ref={ref}
          isMulti
          value={value || []}
          options={options}
          onChange={onChange}
          placeholder={<div className="css-placeholder">{placeholder || "Select subledgers"}</div>}
          isDisabled={disabled}
          classNamePrefix="react-select"
          className={`elevate-dropdown${invalid ? " is-invalid" : ""}`}
          menuPortalTarget={document.querySelector(target || "body")}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          noOptionsMessage={() => "No subledgers"}
        />
      )}
    />
  )
}

export default SubledgersMultiLi
